<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['billing-head-title']"
    :description="propsdata[0]['translation']['billing-head-description']"
/>

    <div v-if="loading" style="margin-top: 150px;">
      <lottie-player src="https://qr.io/lottie/qr-loading.json" background="transparent" speed="1" style="width: 230px; height: 230px; margin: 0 auto;" loop autoplay></lottie-player>
    </div>

    <div v-if="!loading" class="container mb-3">
      <div class="card border-light shadow-soft rounded-top-0 rounded-bottom">
        <div class="card-body p-4">
          <div v-if="!team_member_warning" class="col-12 p-0">
            <div v-if="propsdata[0].plan === 'bank_transfer'">
              <h4 style="margin-bottom: 1rem;">{{propsdata[0]['translation']['billing-bank-transfer-plan-title']}}</h4>
              <p style="margin-bottom: 0;">{{propsdata[0]['translation']['billing-bank-transfer-plan-description']}} <strong>${{propsdata[0].value}}</strong>.</p>
            </div>
            <div v-else>
              <!-- FAILED RECURRING INVOICES -->
              <div v-if="invoices[0].pending_invoice !== null && propsdata[0].canceled !== 'yes' && propsdata[0].cancel_at_period_end !== 'yes'">
                <h4 style="margin-bottom: 1rem;">{{propsdata[0]['translation']['billing-pending-invoice-title']}}</h4>
                <p>{{propsdata[0]['translation']['billing-pending-invoice-description']}}</p>
                <ul class="list-group">
                  <li class="list-group-item border-bottom" style="border-color: #ff0000!important;">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 class="h6 mb-1">
                          <o>{{propsdata[0]['translation']['billing-pending-invoice-subtitle']}}</o>
                        </h3>
                        <small class="text-gray-700">{{propsdata[0]['translation']['billing-pending-invoice-attempted-on']}} {{invoices[0].pending_invoice[0].date}}</small>
                      </div>
                      <div class="col-auto">
                        <a :href="'https://qr.io/retry-payment/'+invoices[0].pending_invoice[0].invoiceid" class="btn btn-outline-dark animate-up-2"><i class="fas fa-undo-alt"></i> {{propsdata[0]['translation']['billing-pending-invoice-retry-button']}}</a>
                      </div>
                    </div>
                  </li>
                </ul>
                <hr>
              </div>
              <!-- FAILED API INVOICES -->
              <div v-if="invoices[0].failed_api_invoices !== null && propsdata[0].canceled !== 'yes'">
                <h4 style="margin-bottom: 1rem;">{{propsdata[0]['translation']['billing-failed-api-invoices-title']}}</h4>
                <p>{{propsdata[0]['translation']['billing-failed-api-invoices-description']}}</p>
                <ul class="list-group">
                  <li v-for="(failed_api_invoice, num) in invoices[0].failed_api_invoices" class="list-group-item border-bottom" style="border-color: #ff0000!important;">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 class="h6 mb-1">
                          <o>{{propsdata[0]['translation']['billing-failed-api-invoices-subtitle']}}</o>
                        </h3>
                        <small class="text-gray-700">{{propsdata[0]['translation']['billing-failed-api-invoices-attempted-on']}} {{failed_api_invoice.date}}</small>
                      </div>
                      <div class="col-auto">
                        <a :href="'https://qr.io/retry-api-payment/'+failed_api_invoice.api_invoice_id" class="btn btn-outline-dark animate-up-2"><i class="fas fa-undo-alt"></i> {{propsdata[0]['translation']['billing-failed-api-invoices-retry-button']}}</a>
                      </div>
                    </div>
                  </li>
                </ul>
                <hr>
              </div>
              <!-- FAILED BULK INVOICES -->
              <div v-if="invoices[0].failed_bulk_invoices !== null && propsdata[0].canceled !== 'yes'">
                <h4 style="margin-bottom: 1rem;">{{propsdata[0]['translation']['billing-failed-bulk-invoices-title']}}</h4>
                <p>{{propsdata[0]['translation']['billing-failed-bulk-invoices-description']}}</p>
                <ul class="list-group">
                  <li v-for="(failed_bulk_invoice, num) in invoices[0].failed_bulk_invoices" class="list-group-item border-bottom" style="border-color: #ff0000!important;">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 class="h6 mb-1">
                          <o>{{propsdata[0]['translation']['billing-failed-bulk-invoices-subtitle']}}</o>
                        </h3>
                        <small class="text-gray-700">{{propsdata[0]['translation']['billing-failed-bulk-invoices-attempted-on']}} {{failed_bulk_invoice.date}}</small>
                      </div>
                      <div class="col-auto">
                        <a :href="'https://qr.io/retry-bulk-payment/'+failed_bulk_invoice.bulk_invoice_id" class="btn btn-outline-dark animate-up-2"><i class="fas fa-undo-alt"></i> {{propsdata[0]['translation']['billing-failed-bulk-invoices-retry-button']}}</a>
                      </div>
                    </div>
                  </li>
                </ul>
                <hr>
              </div>
              <!-- UPDATE CARD -->
              <div v-if="(propsdata[0].paid === 'yes' || propsdata[0].canceled === 'yes' || propsdata[0].canceled_due_attempt2 === 'yes') && cards !== 'no card'">
                <h4 style="margin-bottom: 1rem;">{{propsdata[0]['translation']['billing-payment-method-title']}}</h4>
                <p v-if="cards[0].expiring_card === 'yes'" style="color:#ff0000;">{{propsdata[0]['translation']['billing-card-expiring-1-month']}}</p>
                <p v-if="cards[0].expired_card === 'yes'" style="color:#ff0000;">{{propsdata[0]['translation']['billing-card-expired']}}</p>
                <div class="row">
                  <div class="col-auto">
                    <img v-if="cards[0].brand.toLowerCase() === 'mastercard'" src="https://qr.io/assets/img/mastercard.jpg" style="width: 80px;">
                    <img v-else-if="cards[0].brand.toLowerCase() === 'visa'" src="https://qr.io/assets/img/visa.jpg" style="width: 80px;">
                    <img v-else-if="cards[0].brand.toLowerCase() === 'american express'" src="https://qr.io/assets/img/amex.jpg" style="width: 80px;">
                    <img v-else-if="cards[0].brand.toLowerCase() === 'discover'" src="https://qr.io/assets/img/discover.jpg" style="width: 80px;">
                    <img v-else src="https://qr.io/assets/img/cc_placeholder.png" style="width: 80px;">
                  </div>
                  <div class="col-auto">
                    <p style="margin-bottom: 0;"><strong>{{cards[0].brand}} **** {{cards[0].last4}}</strong></p>
                    <p style="margin-bottom: 0;">{{propsdata[0]['translation']['billing-card-expires']}} <strong>{{cards[0].expiration_date}}</strong></p>
                  </div>
                </div>
                <a class="btn btn-secondary mt-4 animate-up-2" href="https://qr.io/update-card"><i class="fas fa-pen"></i> {{propsdata[0]['translation']['billing-card-update-button']}}</a>
              </div>
              <!-- UPDATE PLAN -->
              <div v-if="(propsdata[0].paid === 'yes' && propsdata[0].cancel_at_period_end !== 'yes' && cards !== 'no card') || (propsdata[0].canceled_due_attempt2 === 'yes' && propsdata[0].canceled !== 'yes')">
                <hr>
                <h4 style="margin-bottom: 1rem;">{{propsdata[0]['translation']['billing-change-subscription-title']}}</h4>
                <p style="margin-bottom: 0;">{{propsdata[0]['translation']['billing-subscription-description-1']}} <strong>${{propsdata[0].value}}/</strong><strong v-if="propsdata[0].plan === 'year'">{{propsdata[0]['translation']['billing-subscription-description-2']}}</strong><strong v-else>{{propsdata[0]['translation']['billing-subscription-description-3']}}</strong> {{propsdata[0]['translation']['billing-subscription-description-4']}} <o v-if="propsdata[0].billing_cycle !== ''">, {{propsdata[0]['translation']['billing-subscription-description-5']}} {{propsdata[0].billing_cycle}}</o>. {{propsdata[0]['translation']['billing-subscription-description-6']}}</p>
                <button v-if="!change_subscription" @click="change_subscription = true" class="btn btn-secondary mt-4 animate-up-2"><i class="fas fa-pen"></i> {{propsdata[0]['translation']['billing-change-subscription-button']}}</button>
                <button v-if="!change_subscription" @click="open_modal_cancel_subscription" class="btn btn-danger mt-4 animate-up-2"><i class="fas fa-times"></i> {{propsdata[0]['translation']['billing-cancel-subscription-button']}}</button>
                <div v-if="change_subscription">
                  <div class="row col-md-12 mt-3" style="margin-left: 0;padding: 0;">
                    <div class="col-md-6 mobilenopadding" style="padding-left: 0;">
                      <div class="pricing-card">
                        <div class="card shadow-soft border-light text-center mt-1">
                          <header class="card-header bg-white p-3">
                            <h2 class="h5 text-primary mb-4">{{propsdata[0]['translation']['billing-change-subscription-monthly-title']}}</h2>
                            <span class="d-block">
                              <span class="display-2 text-dark font-weight-bold">
                                  <span class="align-top font-medium">$</span>35
                              </span>
                              <span class="d-block font-small">/ {{propsdata[0]['translation']['billing-change-subscription-monthly-subtitle']}}</span>
                            </span>
                          </header>
                          <div class="card-body">
                            <ul class="list-group mb-4">
                              <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-monthly-feature-1']}}</li>
                              <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-monthly-feature-2']}}</li>
                              <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-monthly-feature-3']}}</li>
                              <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-monthly-feature-4']}}</li>
                              <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-monthly-feature-5']}}</li>
                              <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-monthly-feature-6']}}</li>
                            </ul>
                            <button v-if="propsdata[0].value === '35.00'" type="button" class="btn btn-gray btn-block" style="cursor:initial;">{{propsdata[0]['translation']['billing-change-subscription-current-plan-button']}}</button>
                            <button v-if="propsdata[0].value !== '35.00' && !changing_plan" @click="open_modal_change_subscription_month" class="btn btn-primary btn-block">{{propsdata[0]['translation']['billing-change-subscription-choose-plan-button']}}</button>
                            <button v-if="propsdata[0].value !== '35.00' && changing_plan" class="btn btn-primary btn-block"><i class="fas fa-spinner"></i> {{propsdata[0]['translation']['billing-change-subscription-loading-button']}}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mobilenopadding" style="padding-right: 0;">
                      <div class="pricing-card">
                        <div class="card shadow-soft border-light text-center mt-1">
                          <header class="card-header bg-white p-3">
                            <h2 class="h5 text-primary mb-4">{{propsdata[0]['translation']['billing-change-subscription-annually-title']}}</h2>
                            <span class="d-block">
                              <span class="display-2 text-dark font-weight-bold">
                                  <span class="align-top font-medium">$</span>350
                              </span>
                              <span class="d-block font-small">/ {{propsdata[0]['translation']['billing-change-subscription-annually-subtitle']}}</span>
                            </span>
                          </header>
                          <div class="card-body">
                            <ul class="list-group mb-4">
                            <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-annually-feature-1']}}</li>
                            <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-annually-feature-2']}}</li>
                            <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-annually-feature-3']}}</li>
                            <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-annually-feature-4']}}</li>
                            <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-annually-feature-5']}}</li>
                            <li class="list-group-item">{{propsdata[0]['translation']['billing-change-subscription-annually-feature-6']}}</li>
                            </ul>
                            <button v-if="propsdata[0].value === '350.00'" type="button" class="btn btn-gray btn-block" style="cursor:initial;">{{propsdata[0]['translation']['billing-change-subscription-current-plan-button']}}</button>
                            <button v-if="propsdata[0].value !== '350.00' && !changing_plan" @click="open_modal_change_subscription_year" class="btn btn-primary btn-block">{{propsdata[0]['translation']['billing-change-subscription-choose-plan-button']}}</button>
                            <button v-if="propsdata[0].value !== '350.00' && changing_plan" class="btn btn-primary btn-block"><i class="fas fa-spinner"></i> {{propsdata[0]['translation']['billing-change-subscription-loading-button']}}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button @click="change_subscription = false" class="btn btn-secondary mt-4 animate-up-2"><i class="fas fa-chevron-left"></i> {{propsdata[0]['translation']['billing-change-subscription-goback-button']}}</button>
                </div>
              </div>
              <!-- REACTIVATE ACCOUNT -->
              <div v-if="propsdata[0].canceled === 'yes' || propsdata[0].cancel_at_period_end === 'yes'">
                <hr>
                <h4 style="margin-bottom: 1rem;">{{propsdata[0]['translation']['billing-reactivate-account-title']}}</h4>
                <p style="margin-bottom: 0;">{{propsdata[0]['translation']['billing-reactivate-account-description-1']}} <strong>${{propsdata[0].value}}/</strong><strong v-if="propsdata[0].plan === 'year'">{{propsdata[0]['translation']['billing-reactivate-account-description-2']}}</strong><strong v-else>{{propsdata[0]['translation']['billing-reactivate-account-description-3']}}</strong> {{propsdata[0]['translation']['billing-reactivate-account-description-4']}}</p>
                <a class="btn btn-secondary mt-4 animate-up-2" :href="'https://qr.io/reactivate-account/'+propsdata[0].unique_id"><i class="fas fa-undo-alt"></i> {{propsdata[0]['translation']['billing-reactivate-account-button']}}</a>
              </div>
              <!-- SHOW INVOICES -->
              <div v-if="invoices[0].paid_invoices !== null">
                <hr>
                <div class="col-md-12 row m-0 p-0">
                  <h4 style="margin-bottom: 1rem;" class="col-md-9 p-0">{{propsdata[0]['translation']['billing-invoices']}}</h4>
                  <router-link class="btn btn-primary animate-up-2 mb-3 col-md-3" to="/dashboard/edit-billing">{{propsdata[0]['translation']['billing-edit-billing-information-button']}} <i class="fas fa-arrow-right"></i></router-link>
                </div>
                <ul class="list-group">
                  <li v-for="(invoice, num) in invoices[0].paid_invoices" class="list-group-item border-bottom">
                    <div class="row align-items-center">
                      <div class="col">
                        <h3 class="h6 mb-1">
                          <a :href="'https://qr.io/invoice/'+invoice.unique_id" target="_blank">{{propsdata[0]['translation']['billing-invoice-id']}} #{{invoice.unique_id}}</a>
                        </h3>
                        <small class="text-gray-700">Billed {{invoice.date}}</small>
                        <small v-if="invoice.type === 'api'" class="text-gray-700" style="display:block;">{{propsdata[0]['translation']['billing-invoice-description-1']}}</small>
                        <small v-if="invoice.type === 'bulk'" class="text-gray-700" style="display:block;">{{propsdata[0]['translation']['billing-invoice-description-2']}}</small>
                      </div>
                      <div class="col-auto">
                        <a :href="'https://qr.io/invoice/'+invoice.unique_id" target="_blank" class="btn btn-secondary animate-up-2"><i class="fas fa-download"></i> {{propsdata[0]['translation']['billing-invoice-download-button']}}</a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes' && propsdata[0].onetime_payment !== 'yes' && propsdata[0].canceled !== 'yes'">
              <h4 class="mb-0">{{propsdata[0]['translation']['billing-invoice-upgrade-account']}}</h4>
            </div>
          </div>
          <div v-if="team_member_warning" class="alert alert-warning mb-0" role="alert">
            <span class="alert-inner--text">{{team_member_warning}}.</span>
          </div>
        </div>
      </div>

      <!-- Modal Change Subscription Month -->
      <div v-if="modal_change_subscription_month" @click="close_modal_change_subscription_month" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
        <div @click.stop class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">{{propsdata[0]['translation']['billing-modal-month-change-plan-title']}}</h6>
              <button @click="close_modal_change_subscription_month" class="close">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>{{propsdata[0]['translation']['billing-modal-month-change-plan-description']}}</p>
            </div>
            <div class="modal-footer">
              <a href="https://qr.io/change-plan.php?plan=sub" class="btn btn-sm btn-success">{{propsdata[0]['translation']['billing-modal-month-change-plan-yes']}}</a>
              <button @click="close_modal_change_subscription_month" class="btn btn-link text-danger ml-auto">{{propsdata[0]['translation']['billing-modal-month-change-plan-close']}}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Modal Change Subscription Month -->
      <!-- Modal Change Subscription Year -->
      <div v-if="modal_change_subscription_year" @click="close_modal_change_subscription_year" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
        <div @click.stop class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">{{propsdata[0]['translation']['billing-modal-year-change-plan-title']}}</h6>
              <button @click="close_modal_change_subscription_year" class="close">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>{{propsdata[0]['translation']['billing-modal-year-change-plan-description']}}</p>
            </div>
            <div class="modal-footer">
              <a href="https://qr.io/change-plan.php?plan=year" class="btn btn-sm btn-success">{{propsdata[0]['translation']['billing-modal-year-change-plan-yes']}}</a>
              <button @click="close_modal_change_subscription_year" class="btn btn-link text-danger ml-auto">{{propsdata[0]['translation']['billing-modal-year-change-plan-close']}}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Modal Change Subscription Year -->
      <!-- Modal Cancel Subscription -->
      <div v-if="modal_cancel_subscription" @click="close_modal_cancel_subscription" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
        <div @click.stop class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">{{propsdata[0]['translation']['billing-modal-cancel-change-plan-title']}}</h6>
              <button @click="close_modal_cancel_subscription" class="close">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-footer">
              <a href="https://qr.io/dashboard/cancel-reasons" class="btn btn-sm btn-success">{{propsdata[0]['translation']['billing-modal-cancel-change-plan-yes']}}</a>
              <button @click="close_modal_cancel_subscription" class="btn btn-link text-danger ml-auto">{{propsdata[0]['translation']['billing-modal-cancel-change-plan-close']}}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Modal Cancel Subscription -->
    </div>
  </div>
</template>

<script>
  export default {
    props:['propsdata'],
    data() {
      return {
        loading: true,
        billing: [],
        cards: [],
        invoices: [],
        change_subscription: false,
        team_member_warning: false,
        modal_change_subscription_month: false,
        modal_change_subscription_year: false,
        modal_cancel_subscription: false
      };
    },
    methods: {
      cargarcards(){
        //CARGAR CARDS
        axios.post('/dashboard/cargar-cards.php', {
        })
        .then(response => {
          this.cards = response.data;
          this.cargarinvoices();
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      cargarinvoices(){
        //CARGAR INVOICES
        axios.post('/dashboard/cargar-invoices.php', {
        })
        .then(response => {
          if(response.data.includes("You cannot access billing information because you are a team member. Please contact the account owner at")){
            this.team_member_warning = response.data;
          }
          else{
            this.invoices = response.data;
          }
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      open_modal_cancel_subscription(){
        this.modal_cancel_subscription = true;
      },
      close_modal_cancel_subscription(){
        this.modal_cancel_subscription = false;
      },
      open_modal_change_subscription_month(){
        this.modal_change_subscription_month = true;
      },
      close_modal_change_subscription_month(){
        this.modal_change_subscription_month = false;
      },
      open_modal_change_subscription_year(){
        this.modal_change_subscription_year = true;
      },
      close_modal_change_subscription_year(){
        this.modal_change_subscription_year = false;
      }
    },
    mounted() {
      this.$emit('updatepath');
      this.cargarcards();
    }
  };
</script>



// WEBPACK FOOTER //
// src/billing.vue